module.exports = __webpack_public_path__ + "fonts/61c5021aa993dc6a8dc29482e5535d21.txt";